import { render, staticRenderFns } from "./TemplateDraftItem.vue?vue&type=template&id=36a94902&"
import script from "./TemplateDraftItem.vue?vue&type=script&lang=js&"
export * from "./TemplateDraftItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports